import { render, staticRenderFns } from "./dash-statistic-event.vue?vue&type=template&id=8639963e&"
import script from "./dash-statistic-event.vue?vue&type=script&lang=js&"
export * from "./dash-statistic-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports